import { FamilyMember } from '@/types';

export function getAncestorLineage(memberId: string, members: FamilyMember[]): string {
  const lineage: string[] = [];
  let currentId = memberId;
  let depth = 0;
  const maxDepth = 5; // Show up to 5 generations

  // Get the initial member's name
  const member = members.find(m => m.id === currentId);
  if (!member) return '';
  lineage.push(member.name);

  // Get ancestors
  while (depth < maxDepth) {
    const parent = members.find(m => m.children.includes(currentId));
    if (!parent) break;
    
    lineage.push(parent.name);
    currentId = parent.id;
    depth++;
  }

  // Join names with "بن" but only between names
  return lineage.reduce((result, name, index) => {
    if (index === 0) return name;
    return `${result} بن ${name}`;
  }, '');
}

export function findAncestors(memberId: string, members: FamilyMember[]): FamilyMember[] {
  const ancestors: FamilyMember[] = [];
  let currentId = memberId;
  let depth = 0;
  const maxDepth = 5; // Show up to 5 generations

  while (depth < maxDepth) {
    const parent = members.find(m => m.children.includes(currentId));
    if (!parent) break;
    
    ancestors.push(parent);
    currentId = parent.id;
    depth++;
  }

  return ancestors;
}